export default __webpack_public_path__ + "static/media/cart-check-img.3aa2005e.png";